import React, { useEffect, useState } from "react";
import NavbarItem from "./navbarItem";
import AuthService from "../app/service/authService";

function SidebarLeft({ isOpen, toggleSidebar, isUsuarioAutenticado, deslogar }) {
  const [openEmpresas, setOpenEmpresas] = useState(false);

  const [organizationalUnit, setOrganizationalUnit] = useState(null);

  useEffect(() => {
    const usuario = AuthService.obterUsuarioAutenticado();
    if (usuario && usuario.ou) {
      setOrganizationalUnit(usuario.ou.toUpperCase());
    }
  }, []);

  // Verifica se é GETIN
  const isGetin = organizationalUnit === "GETIN";
  console.log("É GETIN? " + isGetin);
  

  // Função para aplicar desabilitação visual
  const getDisabledStyle = (isDisabled) =>
    isDisabled
      ? {
          opacity: 0.5,
          cursor: "not-allowed",
          pointerEvents: "none",
        }
      : {};

  return (
    <div
      className={`sidebar_left fixed top-0 left-0 h-full w-64 text-white transform transition-transform duration-300 ease-in-out z-30 ${
        isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
      }`}
    >
      {/* Botão fechar (apenas no mobile) */}
      <div className="flex justify-end lg:hidden px-4 py-3 border-b border-green-700">
        <button onClick={toggleSidebar} className="text-white text-2xl">
          &times;
        </button>
      </div>

      {/* Links */}
      <ul className="mt-10 md:mt-[100px] space-y-1 px-2" >
        <NavbarItem
          render={isUsuarioAutenticado}
          href="#/home"
          label="Home"
          icon="fas fa-home"
          
        />
        <NavbarItem
          render={isUsuarioAutenticado}
          href="#/exportacao-dados"
          label="Exportar dados"
          icon="fas fa-database"
          style={getDisabledStyle(!isGetin)}
        />
        <NavbarItem
          render={isUsuarioAutenticado}
          href="#/geracao-ata"
          label="Gerar atas"
          icon="fas fa-file-pdf"
          style={getDisabledStyle(!isGetin)}
        />
        <NavbarItem
          render={isUsuarioAutenticado}
          href="#/consulta-ata"
          label="Consultar atas"
          icon="fas fa-search"
          style={getDisabledStyle(!isGetin)}
        />

        {/* Menu Empresas com submenus */}
        {isUsuarioAutenticado && (
          <li className="nav-item" style={getDisabledStyle(!isGetin)}>
            <button
              onClick={() => isGetin && setOpenEmpresas(!openEmpresas)}
              className={`btn-empresas flex items-center w-full px-2 py-2 text-left hover:bg-green-700 rounded ${
                openEmpresas ? "active" : ""
              }`}
            >

              <i className="fas fa-building mr-3"></i>
              <span className="menu-empresas">Empresas</span>
              <i
                className={`ml-auto fas fa-chevron-${
                  openEmpresas ? "down" : "right"
                } text-xs`}
              ></i>

            </button>

            {openEmpresas && isGetin && (
              <ul className="ml-2 mt-1 space-y-1">
                <NavbarItem
                  render={isUsuarioAutenticado}
                  href="#/empresas-falidas"
                  label="Falidas"
                  icon="bi bi-graph-down-arrow"
                />
                <NavbarItem
                  render={isUsuarioAutenticado}
                  href="#/empresas-recuperacao-judicial"
                  label="Recup. Judicial"
                  icon="fas fa-balance-scale"
                />
              </ul>
            )}
          </li>
        )}

        <NavbarItem
          render={isUsuarioAutenticado}
          href="#/etiquetas"
          label="Etiquetas"
          icon="bi bi-file-earmark-spreadsheet"
        />

        <NavbarItem
          render={isUsuarioAutenticado}
          onClick={deslogar}
          href="#/login"
          label="Sair"
          icon="fas fa-door-open"
        />
      </ul>
    </div>
  );
}

export default SidebarLeft;